<template>
  <div>
    <b-modal id="add-user-modal" title="Aggiungi utente" size="sm" centered>
      <div class="form-group row mt-3">
        <div class="col-md-6 col-sm-12">
          <label for="">Nome</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="$v.firstName.$model"
          />
        </div>
        <div class="col-md-6 col-sm-12">
          <label for="">Cognome</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="$v.lastName.$model"
          />
        </div>
      </div>

      <div class="form-group mt-3">
        <label for="">Email</label>
        <input
          type="email"
          class="form-control"
          v-model.trim="$v.email.$model"
        />
      </div>

      <div class="form-group mt-3">
        <label for="">Password</label>
        <input
          type="password"
          class="form-control"
          v-model.trim="$v.password.$model"
        />
      </div>

      <div class="form-group mt-3">
        <label for="">Ruolo</label>
        <select class="form-control" v-model.trim="$v.role.$model">
          <option value="utente" selected>Utente</option>
          <option value="archivista">Archivista</option>
          <option value="amministratore">Amministratore</option>
        </select>
      </div>

      <template #modal-footer>
        <div class="w-100">
          <LoadingButton
            :text="'Aggiungi'"
            :classes="['btn-primary', 'w-100']"
            :disabled="$v.$invalid"
            :loading="loading"
            @click="add()"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import UsersService from "@/services/users";
import { required, email } from "vuelidate/lib/validators";

export default {
  props: ["title", "size"],
  data() {
    return {
      email: "",
      password: "",
      role: "utente",
      firstName: "",
      lastName: "",
      loading: false,
    };
  },
  validations: {
    email: {
      email,
      required,
    },
    password: {
      required,
    },
    role: {
      required,
    },
    firstName: {
      required,
    },
    lastName: {
      required,
    },
  },
  methods: {
    async add() {
      this.loading = true;

      try {
        await UsersService.createUser(this.$db, {
          email: this.email,
          password: this.password,
          role: this.role,
          firstName: this.firstName,
          lastName: this.lastName,
        });

        this.clearData();
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.loading = false;
      }
    },

    clearData() {
      this.email = "";
      this.password = "";
      this.role = "utente";
      this.firstName = "";
      this.lastName = "";

      this.$emit("add", true);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/AddUserDialog.vue